/**
 * Base envelope present on every cmd/ack payload — DOC1 §11.2 example shows cmdId+ts.
 */
import { z } from 'zod';
import { Iso8601Schema } from '../common/timestamp.js';
export const CommandEnvelopeSchema = z.object({
    /** Correlation id — middleware mints; device echoes on ack. */
    cmdId: z.string().min(1).max(64),
    /** ISO-8601 timestamp set at send time. */
    ts: Iso8601Schema,
});
//# sourceMappingURL=envelopes.js.map